import axiosInstance from "core/api/axiosInstance";

// Crear nuevo rol
export const createRolService = async (rolData) => {
  try {
    const { data } = await axiosInstance.post("/api/roles", rolData);
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al crear rol");
  }
};

// Actualizar rol
export const updateRolService = async (id, rolData) => {
  try {
    const { data } = await axiosInstance.put(`/api/roles/${id}`, rolData);
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al actualizar rol");
  }
};

// Obtener todos los roles
export const getAllRolesService = async () => {
  try {
    const { data } = await axiosInstance.get("/api/roles/all");
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al obtener roles");
  }
};

// Obtener roles para select (formateados)
export const getRole = async () => {
  try {
    const { data } = await axiosInstance.get("/api/roles/all");

    return data.map((role) => ({
      id: role.id,
      name: role.name,
    }));
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al obtener roles para el select");
  }
};

// Eliminar rol
export const deleteRolService = async (id) => {
  try {
    const { data } = await axiosInstance.delete(`/api/roles/${id}`);
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al eliminar rol");
  }
};
